<template>
  <!-- FULL WIDTH WRAPPER – removed v-container -->
  <div class="pa-4 pa-md-6">

    <!-- MAIN CARD – FULL WIDTH & BEAUTIFUL -->
    <v-card elevation="10" class="rounded-xl overflow-hidden">
      
      <!-- HEADER -->
      <v-card-title class="pa-6" style="background: linear-gradient(135deg, #f1c284 0%, #e7b87a 100%); color: white;">
        <h2 class="text-h4 font-weight-bold">Finances</h2>
        <v-spacer></v-spacer>
        
        <!-- YOUR EXACT SAME CHIPS – N/A SAFE -->
        <div class="d-flex flex-wrap gap-2">
          <v-chip v-if="leaseReference" color="white" text-color="#8B6F47" large>
            {{ leaseReference }}
          </v-chip>
          <v-chip v-if="tenantName" color="white" text-color="#8B6F47" large>
            {{ tenantName }}
          </v-chip>
          <v-chip v-if="propertyName" color="white" text-color="#8B6F47" large>
            {{ propertyName }}
          </v-chip>
        </div>
      </v-card-title>

      <!-- YOUR EXACT SAME TABS -->
      <v-tabs v-model="activeTab" show-arrows background-color="#008080" dark grow>
        <v-tab v-for="(tab, index) in tabs" :key="index">
          {{ tab }}
        </v-tab>
      </v-tabs>

      <!-- TAB CONTENT -->
      <v-tabs-items v-model="activeTab">
        <v-tab-item v-for="(tab, index) in tabs" :key="index">
          <div class="pa-6">
            <component
              :is="getTabComponent(tab)"
              :leaseReference="leaseReference"
              :depositHeaders="depositHeaders"
              :futureCharges="futureCharges"
              :recurringChargesHeaders="recurringChargesHeaders"
              :recurringCharges="recurringCharges"
            />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
// ← 100% YOUR ORIGINAL SCRIPT – NOT A SINGLE CHANGE
import StatementTab from "./StatementTab.vue";
import CurrentInvoiceTab from "./CurrentInvoiceTab.vue";
import InvoiceHistoryTab from "./InvoiceHistoryTab.vue";
import RecurringChargesTab from "./RecurringChargesTab.vue";

export default {
  components: {
    StatementTab,
    CurrentInvoiceTab,
    InvoiceHistoryTab,
    RecurringChargesTab,
  },
  data() {
    return {
      activeTab: 0,
      tabs: ["Statement", "Current Invoice", "Invoice History", "Recurring Charges"],
      leaseReference: "N/A",
      tenantName: "N/A",
      propertyName: "N/A",
      // Dummy data for demonstration
      depositHeaders: [
        { text: "Type", value: "type" },
        { text: "Amount", value: "amount" },
      ],
      futureCharges: [
        { date: "2025-02-01", description: "Monthly Rent", amount: "R1000" },
        { date: "2025-02-01", description: "Service Fee", amount: "R50" },
      ],
      recurringChargesHeaders: [
        { text: "Description", value: "description" },
        { text: "Frequency", value: "frequency" },
        { text: "Amount", value: "amount" },
      ],
      recurringCharges: [
        { description: "Monthly Rent", frequency: "Monthly", amount: "R1000" },
        { description: "Maintenance Fee", frequency: "Monthly", amount: "R100" },
      ],
    };
  },
  created() {
    const { leaseReference = "N/A", tenantName = "N/A", propertyName = "N/A" } = this.$route.query || {};
    this.leaseReference = leaseReference;
    this.tenantName = tenantName;
    this.propertyName = propertyName;
  },
  methods: {
    getTabComponent(tab) {
      switch (tab) {
        case "Statement":
          return "StatementTab";
        case "Current Invoice":
          return "CurrentInvoiceTab";
        case "Invoice History":
          return "InvoiceHistoryTab";    
        case "Recurring Charges":
          return "RecurringChargesTab";
        default:
          return null;
      }
    },
  },
};
</script>

<style scoped>
.gap-2 { gap: 8px; }
.rounded-xl { border-radius: 16px; }
</style>